import { render, staticRenderFns } from "./KJKStephanKolmann.vue?vue&type=template&id=3e655346&"
import script from "./KJKStephanKolmann.vue?vue&type=script&lang=js&"
export * from "./KJKStephanKolmann.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports